import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const REVIEW_PRICE = 90;
const WARRANTY_HOURS = 168;
const CHAIN_PRICE = 24;
const CHAIN_ACTION_PRICE = 3.5;
// Действия со скачиванием: базовая цепочка + 1 ПФ
const DOWNLOAD_CHAIN_PRICE = CHAIN_PRICE * 2;
// ─── Общий FAQ ───────────────────────────────────────────────────────────────

const APP_MARKETS_FAQ = [
  {
    title: 'Что такое Boostclick и как работает сервис?',
    isH3: true,
    text: (
      <p>
        <b>Boostclick</b> — платформа для размещения заданий реальным пользователям.
        <br />
        <br />
        Вы описываете, что нужно сделать с вашим приложением (установить, пройти онбординг, использовать, оставить отзыв), а исполнители выполняют задание на своём устройстве и присылают отчёт.
        <br />
        <br />
        Платформа не использует ботов или автоматизацию — только живые люди с реальными устройствами.
      </p>
    ),
  },
  {
    title: 'Как проходит тестирование приложения?',
    isH3: true,
    text: (
      <div>
        Исполнитель получает задание и:
        <br />
        <br />
        <ol>
          <li>Открывает App Store или Google Play и находит ваше приложение;</li>
          <li>Изучает скриншоты и описание;</li>
          <li>Устанавливает приложение;</li>
          <li>Проходит онбординг и регистрацию;</li>
          <li>Использует приложение 3–5 минут;</li>
          <li>При наличии задания — оставляет оценку или отзыв;</li>
          <li>Присылает отчёт с подтверждением выполнения.</li>
        </ol>
      </div>
    ),
  },
  {
    title: 'Зачем продвигаться через установки?',
    isH3: true,
    text: (
      <p>
        Количество установок, рейтинг и активность пользователей — ключевые факторы ранжирования в App Store и Google Play.
        <br />
        <br />
        Реальные установки от живых пользователей улучшают поведенческие сигналы: время в приложении, глубину сессий, процент сохранения пользователей.
      </p>
    ),
  },
  {
    title: 'Какие гарантии предоставляет Boostclick?',
    isH3: false,
    text: (
      <ul>
        <li>Задание выполняется реальным пользователем вручную;</li>
        <li>У вас есть 72 часа на проверку отчёта;</li>
        <li>Если отчёт не соответствует условиям — запросите замену;</li>
        <li>Boostclick не влияет на алгоритмы App Store / Google Play и не гарантирует рост позиций.</li>
      </ul>
    ),
  },
  {
    title: 'Сколько времени занимает выполнение задания?',
    isH3: false,
    text: (
      <ul>
        <li>Установка и использование — в течение 24 часов;</li>
        {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
        <li>Отзыв после публикации проходит модерацию магазина;</li>
        <li>Полный цикл (установка + отзыв) занимает от 2 до 5 дней.</li>
      </ul>
    ),
  },
  {
    title: 'Исполнитель не удалит приложение сразу?',
    isH3: false,
    text: (
      <p>
        Во всех заданиях со скачиванием мы попросим исполнителя не удалять приложение в течение месяца.
        <br />
        Boostclick не контролирует действия пользователя после сдачи задания, однако исполнители заинтересованы в честном выполнении ради рейтинга на платформе.
      </p>
    ),
  },
  {
    title: 'Вы работаете с юридическими лицами?',
    isH3: false,
    text: (
      <p>
        Да. Предоставляем акты, счета и закрывающие документы через ЭДО.
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя. Каждый
    сценарий начинается с поиска вашего приложения в магазине.
  </p>
);

// ─── Общие действия ──────────────────────────────────────────────────────────

const ACTIONS = [
  // ── ПФ-группа (выделены по умолчанию) ───────────────────────────────────────
  { type: 'ALWAYS.OPEN', icon: 'open', iconHome: 'home-open', title: 'Открыть App Store или Google Play', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: 'search', iconHome: 'home-search', title: 'Ввести поисковый запрос', initialShare: 1 },
  {
    type: 'EXTRA.SIMILAR',
    icon: 'glasses',
    iconHome: 'home-glasses',
    title: 'Посмотреть похожие приложения',
    initialShare: 1,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Похожие',
  },
  { type: 'ALWAYS.OPEN_APP', icon: 'click', iconHome: 'home-click', title: 'Найти приложение и открыть карточку', initialShare: 1 },
  {
    type: 'MAIN.ONBOARDING',
    icon: 'click',
    iconHome: 'home-click',
    title: 'Пройти онбординг',
    initialShare: 1,
    activityType: 'Онбординг',
  },
  {
    type: 'MAIN.STUDY',
    icon: 'eye',
    iconHome: 'home-eye',
    title: 'Изучить скриншоты и описание приложения',
    initialShare: 1,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Изучение',
  },
  {
    type: 'MAIN.INSTALL',
    icon: 'download',
    iconHome: 'home-click',
    title: 'Скачать приложение',
    initialShare: 0,
    pricePerChain: 50,
    activityType: 'Установка',
  },
  {
    type: 'MAIN.RATE',
    icon: 'star',
    iconHome: 'home-star',
    title: 'Скачать приложение + оценить',
    initialShare: 0,
    pricePerChain: 60,
    activityType: 'Оценка',
  },
  {
    type: 'MAIN.REGISTRATION',
    icon: 'people',
    iconHome: 'home-people',
    title: 'Зарегистрироваться в приложении',
    initialShare: 0,
    pricePerChain: 60,
    activityType: 'Регистрация',
  },
  // «Не удалять приложение в течение месяца» не заказывается отдельно:
  // бэкенд сам просит об этом во всех цепочках со скачиванием.

  // ── Отзыв ────────────────────────────────────────────────────────────────────
  {
    type: 'MAIN.REVIEW',
    icon: 'message',
    iconHome: 'home-reviews',
    title: 'Написать отзыв на приложение',
    initialShare: 0,
    price: `от ${REVIEW_PRICE}`,
    itemTitle: 'тест+отзыв',
    activityType: 'Отзыв',
  },
];

// ─── PlayMarket ───────────────────────────────────────────────────────────────

const PLAYMARKET_MAIN_PAGE_TITLES = [
  {
    iconHome: 'home-action',
    title: 'Поведенческая активность',
    path: '/povedencheskie-faktory-na-playmarket',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: 'home-click',
    title: 'Установить приложение',
    path: '/povedencheskie-faktory-na-playmarket',
    target: '_self',
  },
  {
    iconHome: 'home-people',
    title: 'Зарегистрироваться',
    path: '/povedencheskie-faktory-na-playmarket',
    target: '_self',
  },
  {
    iconHome: 'home-glasses',
    title: 'Использовать приложение',
    path: '/povedencheskie-faktory-na-playmarket',
    target: '_self',
  },
  {
    iconHome: 'home-star',
    title: 'Оставить оценку',
    path: '/povedencheskie-faktory-na-playmarket',
    target: '_self',
  },
  {
    iconHome: 'home-reviews',
    title: 'Написать отзыв',
    path: '/reviews-on-playmarket',
    target: '_self',
  },
];

class PlayMarketClass extends Market {

  id = 'playmarket';
  backendId = 'appmarket';
  appMarket = 'playmarket';
  host = 'play.google.com';
  hostsList = [
    'play.google.com',
  ];
  url = 'https://play.google.com/';

  title = 'Google Play';

  isMarketplace = false;
  hasSearchPhrase = true;
  hasNoServicesInReview = true;

  icon = 'playmarket';
  titlePlaces = 'Google Play*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = PLAYMARKET_MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 200 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 4;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = ['Google Play', 'google play', 'Play Market', 'play market', 'Плей Маркет'];

  targetLinkComment = 'Укажите ссылку на приложение в Google Play';
  targetLinkCommentShort = 'Укажите ссылку на приложение';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/povedencheskie-faktory-na-playmarket',
      rating: 0.97,
      title: 'ПФ Google Play',
      navigateTitle: 'ПФ действия с приложением в Google Play',
      icon: 'lightning',
      iconForHomePage: 'home-action',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ на Google Play — установки, отзывы | Boostclick`,
        description: `Продвижение приложения в Google Play от ${CHAIN_PRICE} руб. — реальные установки, оценки, отзывы.`,
        canonical: '/povedencheskie-faktory-na-playmarket',
      },
      intro: {
        title: 'Продвижение приложения в Google Play через ПФ',
        comment: 'Через выполнение микрозадач от реальных Android-пользователей',
        points: [
          'Реальные установки от живых пользователей',
          'Прохождение онбординга и регистрации',
          'Использование приложения 3–5 минут',
          'Оценки и отзывы после реального взаимодействия',
          'Удержание — не удалять приложение в течение месяца',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры ПФ для вашего приложения в Google Play',
      stepPhrase2: 'Укажите название приложения для поиска в Google Play',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать ПФ на Google Play',
      titleFAQ: 'Вопрос-ответ по продвижению приложения в Google Play',
      faq: APP_MARKETS_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => !action.type.startsWith('VIEW.') && action.type !== 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Исполнители используют реальные Android-устройства.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
      ],
    },
    {
      id: MARKET_MODES.REVIEWS,
      path: '/reviews-on-playmarket',
      rating: 0.97,
      title: 'Отзывы',
      navigateTitle: 'Отзывы на приложения в Google Play',
      icon: 'message',
      iconForHomePage: 'home-reviews',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Отзывы на Google Play от ${REVIEW_PRICE} руб. — ЛЮДИ | Boostclick`,
        description: `Реальные отзывы на приложения в Google Play от ${REVIEW_PRICE} руб. Исполнитель устанавливает, использует и пишет отзыв.`,
        canonical: '/reviews-on-playmarket',
      },
      intro: {
        title: 'Получить отзыв на приложение в Google Play',
        comment: 'Тестирование приложения реальными Android-пользователями',
        points: [
          'Отзывы от реальных пользователей после установки и использования приложения',
          'Исполнитель: устанавливает → проходит онбординг → использует → пишет отзыв',
          `Оплата только после выполнения задания (до ${WARRANTY_HOURS} часов)`,
          'Электронный чек после оплаты',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры отзыва на приложение в Google Play',
      stepPhrase2: 'Укажите название приложения для поиска в Google Play',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать отзывы на Google Play',
      titleFAQ: 'Вопрос-ответ по отзывам на Google Play',
      faq: APP_MARKETS_FAQ,
      actions: (() => {
        const pfWithReview = ['MAIN.INSTALL', 'MAIN.ONBOARDING', 'MAIN.USAGE', 'MAIN.REGISTRATION'];
        return [
          ...ACTIONS
            .filter(action => action.type === 'MAIN.REVIEW')
            .map(action => ({ ...action, initialShare: 1 })),
          ...ACTIONS
            .filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.'))
            .map(action => pfWithReview.includes(action.type) ? { ...action, initialShare: 1 } : action),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Оплата — только после подтверждения результата.',
        'Возможность бесплатной замены исполнителя при неудачном размещении отзыва.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на приложение в Google Play';
  invalidUrlStr = 'Укажите корректную ссылку на приложение в Google Play';
}

// ─── AppStore ─────────────────────────────────────────────────────────────────

const APPSTORE_MAIN_PAGE_TITLES = [
  {
    iconHome: 'home-action',
    title: 'Поведенческая активность',
    path: '/povedencheskie-faktory-na-appstore',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: 'home-click',
    title: 'Установить приложение',
    path: '/povedencheskie-faktory-na-appstore',
    target: '_self',
  },
  {
    iconHome: 'home-people',
    title: 'Зарегистрироваться',
    path: '/povedencheskie-faktory-na-appstore',
    target: '_self',
  },
  {
    iconHome: 'home-glasses',
    title: 'Использовать приложение',
    path: '/povedencheskie-faktory-na-appstore',
    target: '_self',
  },
  {
    iconHome: 'home-star',
    title: 'Оставить оценку',
    path: '/povedencheskie-faktory-na-appstore',
    target: '_self',
  },
  {
    iconHome: 'home-reviews',
    title: 'Написать отзыв',
    path: '/reviews-on-appstore',
    target: '_self',
  },
];

class AppStoreClass extends Market {

  id = 'appstore';
  backendId = 'appmarket';
  appMarket = 'appstore';
  host = 'apps.apple.com';
  hostsList = [
    'apps.apple.com',
    'itunes.apple.com',
  ];
  url = 'https://apps.apple.com/';

  title = 'App Store';

  isMarketplace = false;
  hasSearchPhrase = true;
  hasNoServicesInReview = true;

  icon = 'appstore';
  titlePlaces = 'App Store*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = APPSTORE_MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 200 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 4;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = ['App Store', 'app store', 'AppStore', 'Апп Стор', 'iOS'];

  targetLinkComment = 'Укажите ссылку на приложение в App Store';
  targetLinkCommentShort = 'Укажите ссылку на приложение';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/povedencheskie-faktory-na-appstore',
      rating: 0.97,
      title: 'ПФ App Store',
      navigateTitle: 'ПФ действия с приложением в App Store',
      icon: 'lightning',
      iconForHomePage: 'home-action',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Накрутка ПФ ЛЮДИ на App Store — установки, отзывы | Boostclick`,
        description: `Продвижение приложения в App Store от ${CHAIN_PRICE} руб. — реальные установки, оценки, отзывы.`,
        canonical: '/povedencheskie-faktory-na-appstore',
      },
      intro: {
        title: 'Продвижение приложения в App Store через ПФ',
        comment: 'Через выполнение микрозадач от реальных iOS-пользователей',
        points: [
          'Реальные установки от живых iPhone/iPad пользователей',
          'Прохождение онбординга и регистрации',
          'Использование приложения 3–5 минут',
          'Оценки и отзывы после реального взаимодействия',
          'Удержание — не удалять приложение в течение месяца',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры ПФ для вашего приложения в App Store',
      stepPhrase2: 'Укажите название приложения для поиска в App Store',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать ПФ на App Store',
      titleFAQ: 'Вопрос-ответ по продвижению приложения в App Store',
      faq: APP_MARKETS_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => !action.type.startsWith('VIEW.') && action.type !== 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Исполнители используют реальные iOS-устройства (iPhone / iPad).',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
      ],
    },
    {
      id: MARKET_MODES.REVIEWS,
      path: '/reviews-on-appstore',
      rating: 0.97,
      title: 'Отзывы',
      navigateTitle: 'Отзывы на приложения в App Store',
      icon: 'message',
      iconForHomePage: 'home-reviews',
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Отзывы на App Store от ${REVIEW_PRICE} руб. — ЛЮДИ | Boostclick`,
        description: `Реальные отзывы на приложения в App Store от ${REVIEW_PRICE} руб. Исполнитель устанавливает, использует и пишет отзыв.`,
        canonical: '/reviews-on-appstore',
      },
      intro: {
        title: 'Получить отзыв на приложение в App Store',
        comment: 'Тестирование приложения реальными iOS-пользователями',
        points: [
          'Отзывы от реальных пользователей после установки и использования приложения',
          'Исполнитель: устанавливает → проходит онбординг → использует → пишет отзыв',
          `Оплата только после выполнения задания (до ${WARRANTY_HOURS} часов)`,
          'Электронный чек после оплаты',
        ],
      },
      howItWorks: [],
      stepPhrase1: 'Настройте параметры отзыва на приложение в App Store',
      stepPhrase2: 'Укажите название приложения для поиска в App Store',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать отзывы на App Store',
      titleFAQ: 'Вопрос-ответ по отзывам на App Store',
      faq: APP_MARKETS_FAQ,
      actions: (() => {
        const pfWithReview = ['MAIN.INSTALL', 'MAIN.ONBOARDING', 'MAIN.USAGE', 'MAIN.REGISTRATION'];
        return [
          ...ACTIONS
            .filter(action => action.type === 'MAIN.REVIEW')
            .map(action => ({ ...action, initialShare: 1 })),
          ...ACTIONS
            .filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.'))
            .map(action => pfWithReview.includes(action.type) ? { ...action, initialShare: 1 } : action),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий для каждого исполнителя.',
        'Оплата — только после подтверждения результата.',
        'Возможность бесплатной замены исполнителя при неудачном размещении отзыва.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на приложение в App Store';
  invalidUrlStr = 'Укажите корректную ссылку на приложение в App Store';
}

export const PlayMarket = new PlayMarketClass();
export const AppStore = new AppStoreClass();
